import { render } from "./LogoComponent.vue?vue&type=template&id=eb2f584a&scoped=true"
import script from "./LogoComponent.vue?vue&type=script&lang=js"
export * from "./LogoComponent.vue?vue&type=script&lang=js"

import "./LogoComponent.vue?vue&type=style&index=0&id=eb2f584a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb2f584a"]])

export default __exports__